import type { IntegrationMode } from '@/lib/providers/types';

/** The colours of each mode — the chip, the chosen segment of a mode choice, the dialog's warning. */
export const MODE_TONE: Record<IntegrationMode, string> = {
  production:
    'border-rose-300 bg-rose-50 text-rose-700 dark:border-rose-900 dark:bg-rose-950/60 dark:text-rose-300',
  sandbox:
    'border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-900 dark:bg-amber-950/60 dark:text-amber-300',
  mock: 'border-violet-300 bg-violet-50 text-violet-700 dark:border-violet-800 dark:bg-violet-950/60 dark:text-violet-300',
};

